import App from './App';
import ReactDOM from 'react-dom';
import 'src/utils/chart';
import * as serviceWorker from './serviceWorker';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import * as Sentry from '@sentry/react';
// import { PostHogProvider } from 'posthog-js/react';

import 'nprogress/nprogress.css';
import { Provider } from 'react-redux';
import { store } from 'src/app/store';
import client from 'src/services/graphql/settings';
import { StrictMode, Suspense } from 'react';
import './styles.css';
import './i8n';

Sentry.init({
  dsn: 'https://2bfe2d176557a9ffe6c3c2b5e92e0aab@o4509846097821696.ingest.us.sentry.io/4509846100639744',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

const postHogOptions = {
  api_host: 'https://app.posthog.com'
};

ReactDOM.render(
  <StrictMode>
    {/* <PostHogProvider
      apiKey="phc_Cn56X1rGXM9VFGkjsIn8Sa0CTexin4guDI0OSwEwntv"
      options={postHogOptions}
    > */}
    <ApolloProvider client={client}>
      <HelmetProvider>
        <Provider store={store}>
          <BrowserRouter>
            <Suspense fallback={null}>
              <App />
            </Suspense>
          </BrowserRouter>
        </Provider>
      </HelmetProvider>
    </ApolloProvider>
    {/* </PostHogProvider> */}
  </StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
